import { createApp } from 'vue';
import ViewUIPlus from 'view-ui-plus';
import App from './App.vue';
import router from './router';
import 'view-ui-plus/dist/styles/viewuiplus.css';
import $ from 'jquery';
import locale from 'view-ui-plus/dist/locale/en-US';

// 将 jQuery 设为全局可用
window.$ = $;
window.jQuery = $;

const app = createApp(App);

app
  .use(router)
  .use(ViewUIPlus, {
      locale
  })
  .mount('#app');